import { IncodeSMSContainer } from "@containers/common/properties-sections/incode-sms-container/incode-sms-container";
import { PageLevelTypes } from "@enums/page-level-types";
import { GeneralAdvancedValidationErrors } from "@idw-types/common/validation/common/general-advanced-validation-errors";
import { AxnDocumentationLink } from "@idw-types/data/reference-data/axn";
import { FormattedRpServiceConfiguration } from "@idw-types/data/rp-service-configuration";

type VerificationServiceIncodeSmsContainerProps = {
    isDisabled: boolean;
    validationErrors: GeneralAdvancedValidationErrors;
    documentationLinks: Array<AxnDocumentationLink>;
    rpServiceConfiguration: FormattedRpServiceConfiguration;
    updateProperties: (properties: Array<{
        propertyTypeId: string;
        newValue: string;
        added: boolean;
    }>) => void;
}

export const VerificationServiceIncodeSmsContainer = (props: VerificationServiceIncodeSmsContainerProps) => {
    const {
        isDisabled,
        validationErrors,
        documentationLinks,
        rpServiceConfiguration,
        updateProperties
    } = props;

    return (
        <IncodeSMSContainer
            isDisabled={isDisabled}
            incodeSmsMessagingServiceError={validationErrors.incodeSmsMessagingServiceError}
            documentationLinks={documentationLinks}
            appliedProfiles={rpServiceConfiguration.appliedProfiles}
            properties={rpServiceConfiguration.properties}
            pageLevel={PageLevelTypes.APIKEY}
            canModifyNonRestrictedProperties={rpServiceConfiguration.permissions.canModifyNonRestrictedProperties}
            workflowId={rpServiceConfiguration.workflowID}
            updateProperties={updateProperties}
        />
    );
}